module.exports = async (milliseconds) => {
    return new Promise((resolve => {
        setTimeout(() => {
            resolve(true);
        }, milliseconds);
    }))
}